import React, {useEffect, useCallback, useState} from "react";
import {useUserContext} from "../contexts/user-context";
import {useLocation, useNavigate} from "react-router-dom";
import {useDiaForm} from "./dia-form";
import {hookReturn} from '../utils';
import {
    Alert,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText,
    TextField,
    Typography
} from "@mui/material";
import {Cancel, Check,  DevicesOther, Email, Login, SendToMobile} from "@mui/icons-material";
import {ModalWindow} from "./ModalWindow";
import WaitSpinner from "./wait-spinner";

//var Password = Input.Password;

const inputValues = {code: ''};

export const TwoFactorLogin = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const userContext = useUserContext();
    const [isClearAuthenticator, setIsClearAuthenticator] = useState(false);
    const [isEmailLogin, setIsEmailLogin] = useState(false);
    const [emailCode, setEmailCode] = useState('');
    console.log('show 2fa login');
    useEffect(() => {
        console.log('TWOFACTOR LOGIN');
        if (location.pathname !== '/') {
            navigate('/');
        }
    }, []);


    const submit = useCallback(async ({values, hasCompleted }) => {
        await userContext.do2FA(values.code);
        hasCompleted();
    }, [userContext]);
    const diaForm = useDiaForm({
        inputValues: inputValues,
        onSubmit: submit,
        loaded: true
    });
    const input = {
        onChange: diaForm.onChange
    };
    const doneEmailLoginInit = useCallback(() => {
        setIsEmailLogin(true);
    }, []);
    const emailLogout = () => {
        userContext.doLogout();
    };
    const emailLoginInit = () => {
        userContext.emailLoginRequest(doneEmailLoginInit);
    };
    const doneClearAuth = useCallback(() => {
        setIsClearAuthenticator(true);
    }, []);
    const clearAuthenticator = () => {
        return userContext.reset2Fa(doneClearAuth);
    };
    const emailLogin = () => {
        return userContext.emailLogin(emailCode);
    }


    useEffect(() => {
        return hookReturn(function () {
            if (isEmailLogin) {
                return emailLogin();
            }
            if (isClearAuthenticator) {
                return;
            }
            diaForm.handleSubmit();
        });
    }, [submit, isClearAuthenticator, isEmailLogin]);

    if (diaForm.status != 'ready') return <WaitSpinner  variant="overlay"/>;
    if (isClearAuthenticator) {
        return (
            <ModalWindow isOpen={true} onClose={()=>{}} header={
            <>Email sent</>} actions={null} maxWidth="md">
            <Card className="login__card">
                <CardContent>
                    <Alert severity="success" title="Re-register process started">
                        An email has been sent with a link to reset your authenticator app. You can close this window.
                    </Alert>
                </CardContent>
            </Card>
        </ModalWindow>);
    }
    if (isEmailLogin) {
        return (
            <ModalWindow isOpen={true} onClose={() => {
                return;
            }} header="Email login" actions={
                <Button variant="contained" onClick={emailLogin} startIcon={<Check/>}>Validate code</Button>
            } maxWidth="md">
                <Alert severity="success" title="Re-register process started">
                    <Typography variant="caption">An email has been sent with a code to perform login. Please enter the
                        code below</Typography>
                    <TextField fullWidth={true} type="text" label="code from email" value={emailCode} onChange={(e) => {
                        setEmailCode(e.target.value);
                    }}/>

                </Alert>
            </ModalWindow>);
    }

    return (
        <ModalWindow isOpen={true} onClose={() => {
            return;
        }} header={
            <><Login/> Two Factor Authentication Login</>
        } actions={null} maxWidth="lg">
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <form onSubmit={diaForm.handleSubmit}>
                    <Card className="login__card" variant="outlined">
                            <CardHeader title={<><SendToMobile/>2 Factor login</>}/>
                            <CardContent>
                                <TextField name="code" fullWidth={true} type="number" {...input}
                                           value={diaForm.values.code}
                                           label="Please enter the 6 digit code displayed on your Authenticator App for 'Daybook'"/>
                            </CardContent>
                            <CardActions>
                                <Button variant="contained" onClick={diaForm.handleSubmit} startIcon={<Check/>}>Validate
                                    Code</Button>
                            </CardActions>
                    </Card>
                    </form>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Card className="login__card" variant="outlined">
                        <CardHeader title={<><DevicesOther/> Other options</>}/>
                        <CardContent>
                        <List>
                            <ListItem disablePadding>
                                <ListItemButton onClick={clearAuthenticator}>
                                <ListItemIcon><SendToMobile/></ListItemIcon><ListItemText>Register a new
                                    authenticator device/app</ListItemText>
                                </ListItemButton>
                                </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton onClick={emailLoginInit}><ListItemIcon><Email/></ListItemIcon><ListItemText>Temporary Login via email</ListItemText></ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton onClick={emailLogout}>
                                    <ListItemIcon><Cancel/></ListItemIcon><ListItemText>Cancel Login</ListItemText></ListItemButton>
                            </ListItem>
                        </List>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </ModalWindow>
    );
}
